import { startOfDay, endOfDay, subDays } from 'date-fns'

// Date Preset Type
export interface DatePreset {
  label: string
  getValue: () => { from: Date; to: Date }
}

// Date presets for quick selection
export const DATE_PRESETS: DatePreset[] = [
  { label: 'Today', getValue: () => ({ from: startOfDay(new Date()), to: endOfDay(new Date()) }) },
  { label: 'Yesterday', getValue: () => ({ from: startOfDay(subDays(new Date(), 1)), to: endOfDay(subDays(new Date(), 1)) }) },
  { label: 'Last 7 days', getValue: () => ({ from: startOfDay(subDays(new Date(), 6)), to: endOfDay(new Date()) }) },
  { label: 'Last 14 days', getValue: () => ({ from: startOfDay(subDays(new Date(), 13)), to: endOfDay(new Date()) }) },
  { label: 'Last 30 days', getValue: () => ({ from: startOfDay(subDays(new Date(), 29)), to: endOfDay(new Date()) }) },
  { label: 'Last 90 days', getValue: () => ({ from: startOfDay(subDays(new Date(), 89)), to: endOfDay(new Date()) }) },
  { label: 'This week', getValue: () => ({ from: startOfDay(subDays(new Date(), new Date().getDay())), to: endOfDay(new Date()) }) },
  { label: 'This month', getValue: () => ({ from: startOfDay(new Date(new Date().getFullYear(), new Date().getMonth(), 1)), to: endOfDay(new Date()) }) },
]

// Color palettes
export const CHART_COLORS = [
  '#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6', 
  '#ec4899', '#06b6d4', '#84cc16', '#f97316', '#6366f1',
  '#14b8a6', '#a855f7', '#eab308', '#22c55e', '#0ea5e9',
  '#d946ef', '#64748b', '#78716c', '#dc2626', '#059669'
]

export const GRADIENT_COLORS = {
  blue: { start: '#3b82f6', end: '#1d4ed8' },
  green: { start: '#10b981', end: '#059669' },
  orange: { start: '#f59e0b', end: '#d97706' },
  red: { start: '#ef4444', end: '#dc2626' },
  purple: { start: '#8b5cf6', end: '#7c3aed' },
  pink: { start: '#ec4899', end: '#db2777' },
}

// Chart configuration for recharts
export const CHART_CONFIG = {
  messages: { label: 'Messages', color: '#3b82f6' },
  incoming: { label: 'Incoming', color: '#3b82f6' },
  outgoing: { label: 'Outgoing', color: '#10b981' },
  newUsers: { label: 'New Users', color: '#8b5cf6' },
  activeUsers: { label: 'Active Users', color: '#f59e0b' },
  cumulativeUsers: { label: 'Total Users', color: '#ec4899' },
  count: { label: 'Count', color: '#8b5cf6' }
}

// Data limits
export const DEFAULT_CONTACT_LIMIT = 1000
export const DEFAULT_MESSAGE_LIMIT = 5000
export const MAX_TABLE_PAGES = 20
export const MAX_ROW_PAGES = 100

// Tab configuration for dashboard
export type TabId = 'overview' | 'users' | 'messages' | 'escalations' | 'forms' | 'variables' | 'ai-usage'

export interface TabConfig {
  id: TabId
  label: string
  icon: 'BarChart3' | 'Users' | 'MessageSquare' | 'Eye' | 'Flag' | 'Layers' | 'FileText' | 'Zap' | 'ClipboardList'
}

export const DASHBOARD_TABS: TabConfig[] = [
  { id: 'overview', label: 'Overview', icon: 'BarChart3' },
  { id: 'users', label: 'Users', icon: 'Users' },
  { id: 'messages', label: 'Messages', icon: 'MessageSquare' },
  { id: 'escalations', label: 'Escalations', icon: 'Flag' },
  { id: 'forms', label: 'Forms', icon: 'ClipboardList' },
  { id: 'variables', label: 'Variables', icon: 'Layers' },
  { id: 'ai-usage', label: 'Usage & Billing', icon: 'Zap' },
]
